import { render, staticRenderFns } from "./P2PModerationWords.vue?vue&type=template&id=73b4de55&scoped=true&"
import script from "./P2PModerationWords.vue?vue&type=script&lang=js&"
export * from "./P2PModerationWords.vue?vue&type=script&lang=js&"
import style0 from "./P2PModerationWords.vue?vue&type=style&index=0&id=73b4de55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4de55",
  null
  
)

export default component.exports